<template>
  <section v-if="active">
    <slot />
  </section>
</template>

<script>
export default {
  name: 'sliding-tabs-content',
  props: {
    name: {
      type: String,
      required: true,
    },
    titleProps: Object,
    active: Boolean,
    titleComponent: {
      type: String,
      default: 'sliding-tabs-title',
    },
  },
};
</script>
